import ReactHtml from 'react-html-table-to-excel'

export function Excel(contenido)
{
    

    return (
        <>
            <ReactHtml
                id="buton" className="btn btn-success" table={contenido.contenido.tabla} filename={contenido.contenido.nombre}
                sheet="Hoja1" buttonText="Exportar a Excel">
                    
                </ReactHtml>
        </>
    )
}

  